import React from "react";
import { ImageI } from "../../../types";
import { ImageTypeEnum } from "../../../types";
import ImageSelect from "./ImageSelect";

interface IconSelectProps {
  icon: ImageI | null;
  setIcon: (i: ImageI) => void;
  disabled?: boolean;
  labelText?: string;
}

export default function IconSelect({
  icon,
  setIcon,
  disabled = false,
  labelText = "Icon",
}: IconSelectProps) {
  return (
    <ImageSelect
      imageType={ImageTypeEnum.ICON}
      value={icon}
      onChange={(img) => img && setIcon(img)}
      disabled={disabled}
      labelText={labelText}
      allowClear={false}
    />
  );
}
